"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _PinnedReply = _interopRequireDefault(require("../PinnedReply"));

var _BestAnswer = _interopRequireDefault(require("../BestAnswer"));

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PinnedAndBestAnswerSection = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(PinnedAndBestAnswerSection, _PureComponent);

  var _super = _createSuper(PinnedAndBestAnswerSection);

  function PinnedAndBestAnswerSection() {
    (0, _classCallCheck2.default)(this, PinnedAndBestAnswerSection);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PinnedAndBestAnswerSection, [{
    key: "render",
    value: function render() {
      var _bestAnswerAuthorInfo;

      var _this$props = this.props,
          pinnedReply = _this$props.pinnedReply,
          bestAnswer = _this$props.bestAnswer,
          authors = _this$props.authors,
          translatedBestAnswerText = _this$props.translatedBestAnswerText,
          translatedPinnedReplyText = _this$props.translatedPinnedReplyText;
      var bestAnswerAuthorInfo = bestAnswer !== null && bestAnswer !== void 0 && bestAnswer.authorId ? authors === null || authors === void 0 ? void 0 : authors[String(bestAnswer.authorId)] : null;
      var bestAnswerAuthorUserName = bestAnswerAuthorInfo ? bestAnswerAuthorInfo === null || bestAnswerAuthorInfo === void 0 ? void 0 : bestAnswerAuthorInfo.name : '';
      var pinnedReplyAuthorInfo = pinnedReply !== null && pinnedReply !== void 0 && pinnedReply.authorId ? authors === null || authors === void 0 ? void 0 : authors[String(pinnedReply.authorId)] : null;
      var pinnedReplyAuthorUserName = pinnedReplyAuthorInfo ? pinnedReplyAuthorInfo === null || pinnedReplyAuthorInfo === void 0 ? void 0 : pinnedReplyAuthorInfo.name : '';

      var useRichBestAnswer = _common.common.isModuleActive('highlightedBestAnswer');

      if (!pinnedReply && !bestAnswer) {
        return null;
      }

      return (0, _preact.h)("div", null, pinnedReply && (0, _preact.h)(_PinnedReply.default, {
        id: pinnedReply === null || pinnedReply === void 0 ? void 0 : pinnedReply.publicReplyId,
        userName: pinnedReplyAuthorUserName,
        content: translatedPinnedReplyText || pinnedReply.content || ''
      }), bestAnswer && (0, _preact.h)(_BestAnswer.default, (0, _extends2.default)({
        content: translatedBestAnswerText || bestAnswer.content || '',
        publicReplyId: String(bestAnswer.publicReplyId || ''),
        username: bestAnswerAuthorUserName
      }, useRichBestAnswer && {
        authorId: bestAnswer.authorId,
        authorAvatar: bestAnswerAuthorInfo === null || bestAnswerAuthorInfo === void 0 ? void 0 : bestAnswerAuthorInfo.avatar,
        authorUrl: bestAnswerAuthorInfo === null || bestAnswerAuthorInfo === void 0 ? void 0 : bestAnswerAuthorInfo.url,
        authorRank: bestAnswerAuthorInfo === null || bestAnswerAuthorInfo === void 0 ? void 0 : (_bestAnswerAuthorInfo = bestAnswerAuthorInfo.rank) === null || _bestAnswerAuthorInfo === void 0 ? void 0 : _bestAnswerAuthorInfo.name,
        authorTitle: bestAnswerAuthorInfo === null || bestAnswerAuthorInfo === void 0 ? void 0 : bestAnswerAuthorInfo.userTitle,
        authorSignature: bestAnswerAuthorInfo === null || bestAnswerAuthorInfo === void 0 ? void 0 : bestAnswerAuthorInfo.signature,
        repliedAt: bestAnswer.repliedAt
      })));
    }
  }]);
  return PinnedAndBestAnswerSection;
}(_preactCompat.PureComponent);

var _default = (0, _OnDemandTranslations.withOnDemandTranslationProps)(PinnedAndBestAnswerSection, ['translatedBestAnswerText', 'translatedPinnedReplyText']);

exports.default = _default;
var cssAnchorName = 'pinned-and-best-answer-section';
exports.cssAnchorName = cssAnchorName;